import React, { useState } from 'react';
import Backdrop from '@mui/material/Backdrop';
import Box from '@mui/material/Box';
import Modal from '@mui/material/Modal';
import Fade from '@mui/material/Fade';
import Button from '@mui/material/Button';
import Typography from '@mui/material/Typography';
import AppsIcon from '@mui/icons-material/Apps';

import img1 from '../../assets/searchbymenu/11.png';
import img2 from '../../assets/searchbymenu/2.png';
import img3 from '../../assets/searchbymenu/3.png';
import img4 from '../../assets/searchbymenu/4.png';
import img5 from '../../assets/searchbymenu/5.png';
import img6 from '../../assets/searchbymenu/6.png';
import img7 from '../../assets/searchbymenu/7.png';
import img8 from '../../assets/searchbymenu/8.png';
import img9 from '../../assets/searchbymenu/1.png';

import { Link } from 'react-router-dom';
import SignIn from '../../pages/SignIn';
import CenterLocator from '../searchByMenuPages/CenterLocator';
import SolarEntrepreneur from '../searchByMenuPages/SolarEntrepreneur';
import SolarExpert from '../searchByMenuPages/SolarExpert';
import RoofTop from '../searchByMenuPages/RoofTop';
import SiteSurvey from '../searchByMenuPages/SiteSurvey';

const desktopModalStyle = {
	position: 'absolute',
	top: '55%',
	left: '49%',
	transform: 'translate(-50%, -47%)',
	width: 575,
	height: 480,
	bgcolor: '#003056',
	boxShadow: 24,
	p: 4,
};

const mobileModalStyle = {
	position: 'absolute',
	top: '55%',
	left: '50%',
	transform: 'translate(-50%, -47%)',
	width: 400,
	height: 480,
	bgcolor: '#003056',
	border: '2px solid #000',
	boxShadow: 24,
	p: 5,
};

const menuItems = [
	{ to: '/survey', imgSrc: img1, title: 'Solar Calculator', component: null },
	{
		to: '/survey',
		imgSrc: img2,
		title: 'Book a Solar Site Survey',
		component: <SiteSurvey />,
	},
	{
		to: 'https://solarrooftop.gov.in',
		imgSrc: img3,
		title: 'Rooftop Solar Subsidy',
		component: null,
	},
	{ to: '/solarMart', imgSrc: img4, title: 'Solar Mart', component: null },
	{
		to: '/rooftop',
		imgSrc: img5,
		title: 'Rooftop Solar Solution',
		component: <RoofTop />,
	},
	{
		to: '/solarExpert',
		imgSrc: img6,
		title: 'Ask Solar Expert',
		component: <SolarExpert />,
	},
	{
		to: '/solarEntrepreneur',
		imgSrc: img7,
		title: 'Be A Solar Entrepreneur',
		component: <SolarEntrepreneur />,
	},
	{
		to: '/centerLocator',
		imgSrc: img8,
		title: 'Solar Experience Center Locator',
		component: <CenterLocator />,
	},
	{ to: '/signin', imgSrc: img9, title: 'My Account', component: <SignIn /> },
];

export default function TransitionsModal() {
	const [open, setOpen] = useState(false);

	const handleOpen = () => setOpen(true);
	const handleClose = () => setOpen(false);

	const clickOnModalIcon = () => {
		setOpen(!open);
	};

	return (
		<div>
			<Button onClick={handleOpen} style={{ width: '50%' }}>
				<AppsIcon style={{ color: '#fff', fontSize: '32px' }} />
			</Button>
			<Modal
				aria-labelledby='transition-modal-title'
				aria-describedby='transition-modal-description'
				open={open}
				onClose={handleClose}
				closeAfterTransition
				slots={{ backdrop: Backdrop }}
				slotProps={{
					backdrop: {
						timeout: 500,
					},
				}}
			>
				<Fade in={open}>
					<Box sx={desktopModalStyle} xs={mobileModalStyle}>
						<Typography
							id='transition-modal-title'
							variant='h6'
							component='h2'
							className='text-center text-white fw-bold '
						>
							Menu
						</Typography>
						<Typography id='transition-modal-description' sx={{ mt: 1 }}>
							<div className='container-fluid'>
								<div className='col col-md my-2'>
									<div className='row modalrow row-cols-3'>
										{menuItems.map((item, index) => (
											<div key={index} className='col border py-2'>
												<Link
													to={item.to}
													onClick={clickOnModalIcon}
													target={item.component ? null : '_blank'}
												>
													<img
														src={item.imgSrc}
														alt='navmodal_images'
														style={{ width: '50px', display: 'block', margin: '10px auto' }}
													/>
													<h6 className='navModal_h6'>{item.title}</h6>
												</Link>
											</div>
										))}
									</div>
								</div>
							</div>
						</Typography>
					</Box>
				</Fade>
			</Modal>
		</div>
	);
}
